import { lazy } from 'react';
import ReactDOM from 'react-dom/client';

const blocks: { [name: string]: any } = {
  root: lazy(() => import('../xpack/root')),
  gridLayout: lazy(() => import('../xpack/root/GridLayout')),
  header: lazy(() => import('./organisms/header/Header')),
  businessCalculatorResult: lazy(() => import('./organisms/business-rates-calculator/BusinessCalculatorResult')),
  businessCalculatorResultDetail: lazy(() => import('./organisms/business-rates-calculator/BusinessCalculatorResultDetail')),
  stampDutyCalculatorDetail: lazy(() => import('./organisms/stamp-duty-calculator/StampDutyCalculatorResultDetail')),
  peopleSearch: lazy(() => import('./organisms/people-search/PeopleSearch')),
  featuredContent: lazy(() => import('./organisms/header/FeaturedContent')),
  tinyMce: lazy(() => import('./organisms/optimizely/TinyMCE')),
  dropdown: lazy(() => import('./molecules/dropdown-field/DropdownField')),
  leaseExtensionCalculator: lazy(() => import('./organisms/lease-extension-calculator/LeaseExtensionCalculator')),
  propertySearch: lazy(() => import('./organisms/property-search/PropertySearch')),
  shareOverlay: lazy(() => import('./organisms/share-overlay/ShareOverlay')),
  shareOverlayInline: lazy(() => import('./organisms/share-overlay-inline/ShareOverlayInline')),
  crossSiteContentSharing: lazy(() => import('./organisms/cross-site-content-sharing')),
};

const loadComponent = (scriptSection: HTMLScriptElement) => {
  const blockType = scriptSection.getAttribute('data-rct');
  const data = scriptSection.textContent ? scriptSection.textContent : '{}';

  if (!blockType || !data) {
    return;
  }

  const Component = blocks[blockType];

  if (Component) {
    scriptSection.textContent = null;

    const allowedTags = ['div', 'section', 'article', 'aside', 'header', 'footer', 'main', 'nav'];
    const tag = scriptSection.getAttribute('data-tag');
    const section = document.createElement(tag && allowedTags.includes(tag) ? tag : 'section');

    section.className = scriptSection.getAttribute('data-class') ?? '';
    scriptSection.replaceWith(section);

    const props = JSON.parse(data);

    ReactDOM.createRoot(section).render(<Component {...props} />);
  } else {
    return <></>;
  }
};

const loadComponentSSR = async (ssrContainer: HTMLSelectElement) => {
  const blockType = ssrContainer.getAttribute('data-rct');
  let data = ssrContainer.dataset.json;
  const script = ssrContainer.querySelector('script');

  if (script) {
    data = script.textContent ?? undefined;
    script.remove();
  }
  ssrContainer.removeAttribute('data-rct');
  ssrContainer.removeAttribute('data-json');

  if (!blockType) {
    return;
  }

  const Component = await blocks[blockType];

  if (Component) {
    const props = JSON.parse(data ?? '{}');

    ReactDOM.createRoot(ssrContainer).render(<Component {...props} />);
  } else {
    return <></>;
  }
};

const loadComponents = () => {
  // rct stands for 'react component type'
  const scriptSections = document.querySelectorAll('script[data-rct]');

  [].forEach.call(scriptSections, loadComponent);

  const ssrContainers = document.querySelectorAll('div[data-rct]');

  [].forEach.call(ssrContainers, loadComponentSSR);
};

loadComponents();
window.addEventListener('load', () => loadComponents());
window.addEventListener('calculatorReload', () => loadComponents());
